import {log} from 'common/log'

export function focusNextFormElement(hopCount: number = 1, refElement: HTMLInputElement | null | undefined = document.activeElement as HTMLInputElement) {
	if (refElement === null) refElement = document.activeElement as HTMLInputElement | null
	if (!refElement) {
		log.warn('focusNextFormElement() refElement:', refElement)
		return
	}
	//add all elements we want to include in our selection
	const focusableElements = 'a:not([disabled]), button:not([disabled]), input:not([disabled]), textarea:not([disabled]), [tabindex]:not([disabled]):not([tabindex="-1"])'
	const form = refElement && (refElement.form)
	if (form) {
		const f = form.querySelectorAll(focusableElements)
		const focusable = Array.prototype.filter.call(f,
			function (element: any) {
				//check for visibility while always include the current activeElement
				return element.offsetWidth > 0 || element.offsetHeight > 0 || element === refElement
			})
		const index = focusable.indexOf(refElement)
		if (index > -1) {
			const nextElement = focusable[index + hopCount]
			if (nextElement) {
				nextElement.focus()
			}
		}
	} else {
		refElement.dispatchEvent(new KeyboardEvent("keypress", {
			key: "Tab",
		}));
		log.warn('use form to group input elements to make use of "focusNextFormElement()"! Used refElement:', refElement)
	}
}